<script setup lang="ts">
  import { useLogout } from '@/models/logout'
  import SidebarItem from './sidebar-item.vue'

  const logout = useLogout()
</script>

<template>
  <nav class="py-4">
    <sidebar-item
      icon="i-far-chart-line"
      :to="{name: 'home'}">
      Home
    </sidebar-item>
    <sidebar-item
      icon="i-far-users"
      :to="{name: 'employee list'}">
      Karyawan
    </sidebar-item>
    <sidebar-item
      icon="i-far-calendar-clock"
      :to="{name: 'attendance create'}">
      Absensi
    </sidebar-item>
    <sidebar-item
      icon="i-far-car-side"
      :to="{name: 'vehicle list'}">
      Kendaraan
    </sidebar-item>
    <!-- TODO fitur gaji -->
    <!-- <sidebar-item
      icon="i-far-hand-holding-dollar"
      :to="{name: 'paycheck list'}">
      Gaji
    </sidebar-item> -->
    <!-- TODO fitur akuntansi -->
    <!-- <sidebar-item
      icon="i-far-file-spreadsheet"
      :to="{name: 'accounting'}">
      Akuntansi
    </sidebar-item> -->
    <sidebar-item
      icon="i-far-address-book"
      :to="{name: 'customer list'}">
      Customer
    </sidebar-item>
    <sidebar-item
      icon="i-far-screwdriver-wrench"
      :to="{name: 'item list'}">
      Item
    </sidebar-item>
    <sidebar-item
      icon="i-far-file-invoice-dollar"
      :to="{name: 'invoice'}">
      Tagihan
    </sidebar-item>
    <sidebar-item
      icon="i-far-power-off"
      @click="logout()">
      Keluar
    </sidebar-item>
  </nav>
</template>
